module.exports = __webpack_public_path__ + "static/media/Apple iPhone 11 Purple.ac3cd7ae.png";